import { TreeNodeWithChildren } from './types';

export function isNodeWithChildren(node: unknown): node is TreeNodeWithChildren {
  return Boolean(node && typeof node === 'object' && 'children' in node);
}
